import React, { useState } from "react";
import Page from "../components/Page";
import {
  Card,
  Container,
  Dialog,
  DialogContent,
  Snackbar,
} from "@mui/material";
import AddButtomMovimientosBanco from "../sections/@catalogos/bancos/movimientos/AddButtomMovimientos";
import MuiAlert from "@mui/material/Alert";
import BancosMovimientosTable from "../sections/@catalogos/bancos/movimientos/BancoMovimientosTable";
import { useParams } from "react-router-dom";

const BancosMovimientos = () => {
  const { id } = useParams();
  const [openDialog, setOpenDialog] = useState(false);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [errorGraph, setErrorGraph] = useState({
    severity: "",
    mensaje: "",
  });

  const [bodyDialog, setBodyDialog] = useState("");
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackBar(false);
  };
  return (
    <>
      <Page title="Movimientos Bancarios">
        <Container maxWidth="xl">
          <AddButtomMovimientosBanco
            setOpenDialog={setOpenDialog}
            setBodyDialog={setBodyDialog}
            setErrorGraph={setErrorGraph}
            setOpenSnackBar={setOpenSnackBar}
            id={id}
          />
          <Card>
            <BancosMovimientosTable
              id={id}
              setOpenDialog={setOpenDialog}
              setBodyDialog={setBodyDialog}
              setErrorGraph={setErrorGraph}
              setOpenSnackBar={setOpenSnackBar}
            />
          </Card>
        </Container>
        <Dialog open={openDialog}>
          <DialogContent>{bodyDialog}</DialogContent>
        </Dialog>
        <Snackbar
          open={openSnackBar}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={errorGraph.severity}
            sx={{ width: "100%" }}
          >
            {errorGraph.mensaje}
          </Alert>
        </Snackbar>
      </Page>
    </>
  );
};

export default BancosMovimientos;
